/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetHealthStatusRequest} from '@cash-web/protos/squareup/cash/marketprices/service.pb'
import {GetHealthStatusResponse} from '@cash-web/protos/squareup/cash/marketprices/service.pb'


export const getHealthStatus = (request:GetHealthStatusRequest, options?: CashRequestOptions) => post<GetHealthStatusRequest, GetHealthStatusResponse>("/2.0/cash/get-health-status", request, {...options, rejectOnError: true })